import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { isAcceptablePhoneNumber } from "../utils/phone.utils";

/** @param existingPhones stored contact numbers, kept as is they do not need the stricter rule (MED-1653). */
export const emergencyContactSchema = (t: TFunction, existingPhones: readonly string[] = []) =>
  z.object({
    firstName: z.string().nonempty(t("common.validation.required")),
    lastName: z.string().nonempty(t("common.validation.required")),
    relationship: z.string().nonempty(t("common.validation.required")),
    phoneNumber: z
      .string()
      .nonempty(t("common.validation.required"))
      .refine((val) => isAcceptablePhoneNumber(val, existingPhones), {
        message: t("common.validation.invalidPhoneNumber"),
      }),
    // MED-1687: optional — an untouched field is "", which .email() alone refused
    email: z.union([z.literal(""), z.email(t("common.validation.invalidEmail"))]).optional(),
    priority: z.number().min(0).max(4).default(1),
  });

export const useEmergencyContactSchema = () => {
  const { t } = useTranslation();
  return emergencyContactSchema(t);
};

export type EmergencyContactSchema = z.infer<
  ReturnType<typeof useEmergencyContactSchema>
>;
